import { HardDrive, ShieldCheck } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { GoogleDriveAuth } from '@/features/auth/components/google';

interface OwnerDriveRequiredDialogProps {
  open: boolean;
  ownerEmail: string;
  connectedEmail?: string | null;
  onConnected: () => void;
}

export const OwnerDriveRequiredDialog = ({
  open,
  ownerEmail,
  connectedEmail,
  onConnected,
}: OwnerDriveRequiredDialogProps) => {
  const hasWrongAccount = !!connectedEmail && connectedEmail.toLowerCase() !== ownerEmail.toLowerCase();

  return (
    <Dialog open={open} onOpenChange={() => undefined}>
      <DialogContent
        showCloseButton={false}
        onEscapeKeyDown={(event) => event.preventDefault()}
        onPointerDownOutside={(event) => event.preventDefault()}
        onInteractOutside={(event) => event.preventDefault()}
        className="sm:max-w-md"
      >
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 text-blue-600">
            <HardDrive className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center">Kết nối Google Drive để tiếp tục</DialogTitle>
          <DialogDescription className="text-center">
            Ảnh của blog sẽ được lưu trong Google Drive của bạn. Hãy cấp quyền bằng tài khoản{' '}
            <strong className="text-foreground">{ownerEmail}</strong>.
          </DialogDescription>
        </DialogHeader>

        {hasWrongAccount && (
          <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
            Drive hiện đang liên kết với <strong>{connectedEmail}</strong>. Vui lòng chọn đúng tài khoản{' '}
            <strong>{ownerEmail}</strong> để tránh lưu ảnh nhầm nơi.
          </div>
        )}

        <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
          <ShieldCheck className="h-4 w-4" />
          Chỉ chủ blog mới cần thực hiện bước này.
        </div>

        <DialogFooter className="sm:justify-center">
          <GoogleDriveAuth forceReauthorize onConnected={onConnected} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
